import { MarginCtrParams } from '../types';

export default class Margin {
  top = 0;
  bottom = 0;
  left = 0;
  right = 0;

  constructor(value?: number | MarginCtrParams) {
    if (!value) return;
    if (typeof value === 'number') {
      this.top = value;
      this.bottom = value;
      this.left = value;
      this.right = value;
    } else {
      this.top = value.top;
      this.bottom = value.bottom;
      this.left = value.left;
      this.right = value.right;
    }
  }

  total() {
    const tot = this.top + this.bottom + this.left + this.right;
    return tot;
  }
}
